module.exports = {
 "+/R6RX": "任务状态",
 "+/nbWD": "下一次可变更时间{time}",
 "+1Wujb": "{num}条",
 "+4lD9e": "姓名",
 "+Bas2b": "时长: {duration}",
 "+CLSks": "2. 此命名规则要套用的设备系统类型",
 "+CP3nr": "选择任务",
 "+GQdfc": "更新Token",
 "+L9lak": "套用报警模板",
 "+TzicH": "门店",
 "+a6DnG": "审核中",
 "+bRanp": "请填写通知上限次数",
 "+cCXuw": "从文件选择图片",
 "+d7aNN": "报警模板列表",
 "+gbx50": "报警条件",
 "+m8vFq": "命名规则详情",
 "+wet4N": "验证码错误",
 "+x/2kt": "设备规则",
 "/5RjKG": "token 失效",
 "/BzHXM": "选择创建人",
 "/CFd+q": "开",
 "/COTHZ": "报警模块名称不能为空",
 "/CxA3j": "添加子门店",
 "/cqdKk": "下载",
 "/k2Fs5": "配置命名规则",
 "/l9tS2": "未触发",
 "/sI6h+": "人",
 "03eM6t": "200条/页",
 "05KCjo": "App icon：",
 "0JCY6+": "部署人",
 "0JQoTX": "审核失败",
 "0KH9Qi": "设备系统类型",
 "0Ru5zG": "尺寸: {size}",
 "0UhE3z": "播放状态",
 "0YYUNG": "已选择{num}个标签",
 "0Z908D": "同一个应用只能选择一个版本",
 "0bBO2n": "版本",
 "0btyN9": "时长:",
 "0cZQXI": "通过程序包id添加",
 "0iTEVO": "查看Token",
 "0nwYmb": "全部通知类型",
 "0sn8j/": "请填写姓名",
 "0xm1Zu": "锁定组合键",
 "1/U2kj": "视频",
 "12LEcf": "是否确认禁用（{name}）该命名规则？",
 "1M03Dq": "排程模板",
 "1PtjRr": "设备名称",
 "1Qoc6t": "进程名称：",
 "1SslIM": "关闭应用",
 "1ULJr+": "单应用模式",
 "1UXyeT": "触发时间",
 "1WymPU": "选择报警触发值",
 "1gjtU2": "最后执行时间",
 "1qoi3T": "图片",
 "1sj5Sj": "移除所有本设备套用的排程模版",
 "2+X2n8": "批量删除",
 "2/LdaO": "门店配置信息",
 "28oE7E": "未选择任何设备",
 "29A4OA": "公司成员",
 "2MYr1m": "登录",
 "2QzYmY": "取消",
 "2Rco7+": "上传时间：",
 "2V19bd": "配置文件详情",
 "2ffDGT": "是否确认关闭排程任务？关闭后设备将不执行该排程模板。",
 "2l+gFk": "是否确认启用（{name}）该排程模板？启用后设备可以引用该模板。",
 "2opnVU": "执行期间",
 "2r/XUW": "移除所有本标签套用的排程模版",
 "2rDc7R": "报警规则不能为空",
 "2t0Cct": "部署日期",
 "32AbcK": "选择公司",
 "32HMy/": "{nubis} Cast版本",
 "33bmiC": "父目录不存在",
 "35v5wD": "是否确认重置报警历史？",
 "36+mbi": "处理状态",
 "36pf2y": "内容历史",
 "3HqLlX": "新增内容",
 "3HzQUc": "导出JSON",
 "3JwoQQ": "上传失败，该应用程序无法解析。",
 "3K02K/": "wifi配置填写不全",
 "3QXG/d": "Ora版本",
 "3RVwfq": "请填写注解",
 "3aYG4L": "移除设备目前所套用的报警模板，不再监控与发送报警",
 "3izvEF": "选择档案",
 "3qF993": "您不能转移不在当前公司的设备。",
 "3qVnoZ": "设备数（{num}）",
 "3qgucc": "手动设置时区",
 "3xlnbE": "命令时间",
 "3yichR": "最后修改时间",
 "4/e9qs": "请填写名称",
 "47GdDb": "关闭",
 "4Regzm": "门店清单",
 "4UcMA+": "添加Wi-Fi",
 "4VVrWd": "是否确认禁用（{name}）该报警模板？禁用后新增报警设备将不能套用该模版。",
 "4c3uw8": "移出门店",
 "4ia8sI": "功能控制",
 "4jU7ke": "启动内容播放器",
 "4nG/GN": "内容名称",
 "4o167y": "自定义文字长度不能超过30",
 "4vWL+W": "导入设备",
 "4wi+/p": "范本",
 "5+oaTO": "image最后更新状态",
 "5Cm9U3": "消息通知",
 "5EJNIu": "跨公司搜设备",
 "5FboZ/": "类型",
 "5Hy0Qx": "不可转移到同一门店",
 "5JrKIs": "功能部署已安排在选定的发布时间。",
 "5RR9aM": "批量暂停",
 "5SSVAQ": "新增报警模板",
 "5XSNyG": "上传素材成功",
 "5ZgUEM": "编辑配置模板",
 "5d3yZi": "生效时间",
 "5grmob": "请填写邮箱",
 "5jpkHg": "在线状态",
 "5noX9X": "配置文件名称",
 "5p8cBO": "账号管理",
 "5ytYaf": "新增排程模板",
 "6+iYA0": "序号",
 "60Ixlm": "报警模板名称",
 "65DvZ1": "输入上限：4",
 "66awCH": "刷新",
 "6ABIlp": "触发状态",
 "6K/a0B": "暂停",
 "6Ty5/G": "发布成功",
 "6kNt8v": "下一小时",
 "6mjOF/": "批量重置",
 "6oXjFu": "上传格式有误",
 "6pDRb2": "请输入有效的密码",
 "6wAcmz": "请选择时间",
 "6x6nu5": "实际执行时间",
 "70JpVD": "进程名称",
 "7G1c4h": "设备列表",
 "7NmXNy": "当前程序信息",
 "7OW60G": "清选择时间",
 "7Ouq4k": "顺序: {sort}",
 "7PkBL6": "启用静默更新",
 "7cAtfM": "次",
 "7ip592": "1. 命名规则名称",
 "7wofGo": "应用",
 "88CuCZ": "3. 为注册在此门店的设备建立命名方式（自动填充设备名称）",
 "8DORrA": "USB端口",
 "8PESa6": "禁用",
 "8WYGi+": "确定要复制吗？",
 "8huAxo": "新增规则",
 "8pB1C7": "添加应用",
 "8u3CYe": "命名规则名称",
 "8vC+0s": "必须选择一个播放内容",
 "8zN+hZ": "执行应用",
 "8zQ4So": "程序包ID：",
 "919TK9": "支持格式：xls、xlsx",
 "96Mzoq": "已完成",
 "96c3gX": "格式",
 "99tjyG": "IP",
 "9Fvzl9": "批量发布",
 "9Kfib+": "未知错误",
 "9RNrDU": "是否为代理设备",
 "9UZxwP": "请输入验证码",
 "9UefLp": "标签",
 "9a/nvJ": "操作结果",
 "9bgunT": "关闭后，您可自行下载新版{ora}安装，或是透过设备命令-{ora}更新进行手动更新。",
 "9c8SPP": "尺寸",
 "9iKk2b": "起始号码",
 "9kkcTB": "删除排程模板",
 "9ljNkr": "重新发送",
 "9mG+jv": "文件大小超过可用空间",
 "A/eXwT": "移除所有本标签套用的报警模版",
 "AFZDo7": "安装历史",
 "AFx0WP": "搜索类型",
 "AH+jWQ": "Windows应用程序",
 "ANeFu6": "验证密码",
 "AlFkwq": "已安装设备数量",
 "AxZAkZ": "本平台上傳的數位內容將經由 Amazon Rekognition內容審核 自動審查，以降低公開發佈的風險。若自動審查未通過，您可選擇手動審核通過；但在此情況下，本平台將不對任何後續影響承擔責任。",
 "Axagls": "请选择结束时间",
 "AyWMlZ": "添加排程任务",
 "B57Wbu": "未选择设备",
 "BBpRbn": "移除所有本门店套用的报警模版",
 "BC52ne": "已忽略",
 "BC74I9": "提示信息",
 "BQcLxf": "下移",
 "BYbqwY": "将文件拖到此处 或点击上传",
 "BdDDD0": "设备日志",
 "BhWZJo": "资源名称",
 "BiPxfI": "添加排程模板",
 "BqUpjt": "请填写包名，例如 com.android.chrome",
 "BwXapw": "分类名称请控制在500字符内",
 "ByhhM1": "条件",
 "C+cw77": "壁纸配置",
 "C55Kjj": "播放内容",
 "C6cGK1": "排程模板名称不能为空",
 "C8ZuKU": "图片宽度",
 "CLqPBU": "编辑",
 "CM76+/": "是否确认启用（{name}）该模板？启用后设备可以引用该模版",
 "CPTAAj": "自然数递增",
 "CqT/5i": "此文件已被共享，确认要移除此文件吗？",
 "CqlH6G": "套用门店列表",
 "CxuMXm": "必须添加一个应用",
 "D+32Ow": "资源管理中心",
 "D//rZg": "是否确认删除排程模板的套用？",
 "D/Yid+": "是否启用",
 "D2KnIQ": "关联门店成功",
 "D3lDHK": "添加报警规则",
 "D5HOUz": "选择状态",
 "DADacD": "移除所有本门店套用的排程模版",
 "DpnauN": "时间",
 "E0Czos": "图片高度",
 "E1GPl7": "拥有者",
 "E2kRYi": "批量启用",
 "E62yo0": "功能部署失败，正在重试。",
 "E6G3sr": "Kiosk模式",
 "EBMdAL": "创建成功",
 "ECm6hH": "是否确认删除（{name}）该资源？",
 "EGvInA": "设备报警列表",
 "ELFG/t": "搜索设备",
 "EZ+vMa": "模板注解",
 "Em0SLE": "重启",
 "EwM8Kj": "确定要移出吗？",
 "EwTMGn": "是否确认启用（{name}）该排程？",
 "Ey9rBq": "确定要删除吗？",
 "F2LJDJ": "确定要移除吗？",
 "F56ZKt": "选择成员",
 "FEb7U2": "确认",
 "FQK+2G": "文件同步",
 "FWlWJR": "查看门店信息",
 "FaJ/jI": "没有选择要导入的文件",
 "FbCeo1": "触发值",
 "FbsCUK": "手机",
 "FeJVkL": "添加例外对象",
 "Fi4xFb": "上传Android应用程序成功",
 "Fir0oq": "请选择通知类型",
 "Fr1I/b": "贴标签",
 "Ft60hS": "Nubis设备",
 "FtTdh0": "1. {ora}自动更新",
 "G+BH4o": "是否确认删除（{name}）当前设备？",
 "G4XFn6": "硬体型号",
 "G9APSK": "编辑命名规则",
 "G9WbnV": "针对门店",
 "GKSW97": "批量禁用",
 "GQ5EVQ": "请至少勾选一个",
 "GRfLaO": "应用程序名称",
 "GUMdjP": "最后执行状态",
 "Gk0Mt5": "是否确认重置（{name}）该报警设备？重置后报警规则将继续执行监控。",
 "GnzEo7": "image最后更新时间",
 "Gp3iu0": "上传本地壁纸",
 "GpzsBd": "开启排程任务",
 "GujK99": "若后续报警模板的内容有更新，也会同步给套用的设备",
 "Gvm3Ry": "是否确认重启（{name}）的{appName}？重启后将继续执行应用监控。",
 "Gwj7xc": "恢复默认",
 "GyqBiS": "打印信息",
 "H15ECl": "输入应用",
 "HDYjnT": "当前选择的应用版本低于已存在的应用，可能会造成应用程序安装失败，请确认应用是否选择正确，如需安装较低版本的应用，可勾选删除原程序后再安装。",
 "HI1PTY": "输入文件夹路径",
 "HI9nIp": "移除文件",
 "HN1dNJ": "所有账号",
 "HNavdr": "公司名称",
 "HOHQFs": "命名规则名称不能为空",
 "HdxQ2/": "门店关联的配置文件与命名规则",
 "I/k8FH": "发布",
 "I73XLQ": "图片纵坐标",
 "IM8kXz": "是否确认删除（{name}）的套用？",
 "IP9Kbk": "图片最大不能超过15MB",
 "IS73A4": "起始时间不能大于结束时间",
 "IX5jed": "配置文件部署状态",
 "IbWDVg": "版本号必填",
 "Ie9WHB": "上传素材",
 "IqkgWZ": "关键字",
 "Iwt/8W": "注解",
 "Ixi8kg": "重启提醒",
 "IyhhzI": "创建配置文件",
 "J0D5h+": "开始时间",
 "J3BW/8": "请输入您email收到的验证码",
 "J3dxzb": "Nubis 目前支持 JPEG 和 PNG 图像格式。视频必须使用 H.264 编解码器进行编码。支持的文件格式包括 MPEG-4 和 MOV。编解码器是一种软件或硬件，用于压缩数据以加快传输速度，并将接收到的数据解压缩回其原始格式。H.264 编解码器通常用于视频内容的录制、压缩和分发。一个视频文件格式可能包含一个或多个编解码器。如果您的 MOV 或 MPEG-4 格式视频文件未通过审核，请检查用于编码视频的编解码器是否为 H.264。",
 "J9jPRL": "复制成功",
 "JJl2M9": "导出",
 "JPIKnb": "主屏幕",
 "JbroVc": "Nubis Cast",
 "JeJAmT": "重命名",
 "Jh62y5": "所有设备",
 "Jp7u8z": "台",
 "KOVFgK": "待审核",
 "KW8qOm": "选择模板",
 "KXqGQe": "批量开启",
 "KetfTt": "图片最大尺寸：500KB",
 "Kj5TRg": "待安装设备数",
 "Km733q": "请选择开始时间",
 "Ko5CPO": "是否确认重置该报警历史？",
 "L24ioQ": "标题",
 "L3HWwz": "设备描述",
 "L4w/Vo": "最新版本",
 "LADN1a": "排程执行情况",
 "LNGTru": "设备排程失败列表",
 "LWSLHa": "温馨提示",
 "Lfia0v": "设置排程",
 "LjaYAu": "(应用设置后设备将会自动重启)",
 "Lqca+c": "Player切换",
 "Ls1X2Z": "已处理",
 "LuP+H0": "描述",
 "LwhdsE": "切换多选",
 "M0GExq": "若设备已存在app，移除原本版本重新安装",
 "M5Vtr/": "编辑模版",
 "MDACCo": "播放成功",
 "MI3yI1": "正在上传 {percentCompleted}%",
 "MMqJtu": "必须选择一个图片或视频",
 "MRe8Q9": "版本号：",
 "MWJG8I": "名称: {name}",
 "MbqxKj": "模板名称",
 "MnTdIi": "触发次数",
 "MufYuw": "锁屏",
 "MvGPdx": "是否确认启用（{name}）该报警模板？启用后新增报警设备可以套用该模版。",
 "Mxw3XE": "bat文件没有命名为install或者uninstall",
 "N3h+Aq": "该功能部署失败",
 "N4np50": "通知上限次数",
 "NDjXUx": "输入指令以部署文件：",
 "NDmD8V": "是否确认删除（{name}）该排程模板？",
 "NGe0Cs": "删除排程执行记录",
 "NM/lRq": "取消上传",
 "NPjnPZ": "亮度",
 "NTanl8": "添加报警模板",
 "NW8FV4": "设备命令状态",
 "NrEurQ": "上传 Mbps",
 "Nrx60r": "下载 Mbps",
 "OCp4OD": "查看配置文件",
 "OVecAI": "成功",
 "OY+bYK": "确认，以后不再显示",
 "OYWCEU": "本地上传应用",
 "OiP4rW": "当前已有配置文件关联门店，请检查。",
 "OjLqmy": "未知",
 "OsMncl": "未开启",
 "OuXnTb": "是否确认重置该USB端口?",
 "OwtOn5": "总状态",
 "Oyd/7c": "手动批准",
 "P/eul9": "否",
 "P6YSaZ": "报警历史记录",
 "P76mDe": "同步文件管理",
 "PDFXBi": "立即发布",
 "PTc6Gt": "启用排程",
 "PZD5BD": "此项目已被【{name}】配置文件所使用，无法删除，若要删除项目请至配置文件中将项目移除",
 "PaMvre": "报警规则列表",
 "PcCooF": "报警触发值",
 "Pdx/YD": "密码",
 "Pg5mqb": "横向模式",
 "PgNsL5": "部署中",
 "PkLYZS": "设备命名规则",
 "PlNIQ9": "系统设置",
 "PnYplH": "设备",
 "Pv/1oy": "内容展示",
 "Py/5UG": "操作的节点已不存在，请重新操作",
 "PyHYs3": "关闭VNC连接",
 "Pzsa4g": "功能部署已准备就绪",
 "Q+0CDu": "新增命名规则",
 "Q2/NzC": "已选择{num}台设备",
 "Q5vbU5": "程序包ID不一致",
 "QHhMxE": "选择角色",
 "QNomO6": "请输入版本号",
 "QSjBm5": "文件不存在",
 "QV3pnn": "状态",
 "QWNGGT": "设备数量",
 "QZCAIP": "应用程序ID",
 "QZM++f": "是否确认重置该打印机?",
 "QavrS/": "规则名称",
 "QgHuyM": "门店命名规则",
 "QpOtgZ": "门店名称",
 "QwHI8Q": "查询结果：",
 "QwmhEP": "内容历史记录",
 "R2D5Dv": "创建时间",
 "R3TTCW": "编辑报警模板",
 "R9TpN6": "预计安装时间",
 "RCjVsb": "设备ID",
 "RFear4": "2. 设备可更新时间段（当地时间）",
 "RJpihQ": "是否确认禁用该USB端口?",
 "RNaGVr": "任务失败列表",
 "RQyKsa": "平台公告",
 "RUMaeu": "请将报警规则填写完整",
 "RWBRyt": "设备分布地图建设中",
 "RY4VVr": "上传者",
 "Rkh3mc": "上一小时",
 "RndUeh": "预计执行时间",
 "Rrwy85": "创建者",
 "RuFFf/": "是否确认禁用（{name}）该排程模板？禁用后设备无法引用该模板。",
 "RyXQqJ": "上传时间",
 "S1QSWC": "汇入子门店",
 "S57QRB": "Filter by",
 "SGDlQ6": "共{total}条",
 "SPyEF8": "选择模式",
 "SbZhau": "开机任务需要指定一个开机设备",
 "SkK50H": "请添加排程任务",
 "SsOQaU": "必须设置Android设备路径",
 "SwMBFl": "套用排程模板",
 "SzN0Xf": "解除Device Owner",
 "T3CtvK": "分类名称不能为空",
 "T8Y38H": "图片文件（*.jpg/*.png）",
 "TDSTTj": "选择排程模板",
 "TDuPUp": "已触发",
 "TYAJpp": "已选择{num}个门店",
 "TiK9WZ": "进程名称必填",
 "TqDOFU": "请勿频繁发送验证码！",
 "Trt6ju": "是否确认开启排程任务？开启后设备需执行该排程任务。",
 "TvOGLc": "部署文件指令",
 "U2DqqT": "搜索公司",
 "UBbWUL": "未选择任何模板",
 "UFjZVV": "部署状态",
 "UH1kCc": "添加",
 "UHuNzJ": "请输入指令",
 "UMU42c": "选择设备",
 "UUtqvk": "未处理",
 "UcumBq": "报警通知",
 "UduVZX": "选择文件",
 "UfxykZ": "原因",
 "UiVtQS": "批量关闭",
 "Unr58u": "更新时间",
 "Unvxiq": "切换账号",
 "Usn1oq": "纵向模式",
 "Ut8+i2": "审核通过",
 "UtE0dS": "操作",
 "Uu/nFu": "移除所有本设备套用的报警模版",
 "Uzdb6l": "设备类型：",
 "V0RiZp": "操作成功",
 "V6d4dz": "操作详情",
 "VJ7wHx": "待安装设备数量",
 "VR6zMp": "确定要禁用吗？",
 "VRizgn": "请填写手机号",
 "VUYwkz": "请选择应用",
 "Vd3wZV": "整体",
 "Ve9Ksw": "转移门店",
 "ViVQNi": "角色",
 "VqEr9u": "套用门店数",
 "VvutjQ": "功能",
 "WI3Hl5": "视频横坐标",
 "WdyIyo": "运作时长",
 "WeKYMe": "最后命令时间",
 "WfS4rv": "操作人：",
 "Wp6QLH": "是否确认重置（{name}）该报警规则？重置后报警规则将继续执行监控。",
 "WwRq+y": "请添加报警通知对象",
 "WxPZOH": "执行{num}次",
 "WypzMq": "排程任务",
 "Wzv7kF": "请选择一个门店",
 "X+8ega": "Kiosk 模式选择",
 "X/cNgA": "删除提醒",
 "X2m4ec": "禁用排程模板",
 "XFEq9J": "模板状态",
 "XG2wHz": "部署成功",
 "XLdI1+": "Wi-Fi强度",
 "XMBOec": "移除标签",
 "XPoLPc": "功能部署已收到，即将处理。",
 "XbIN5K": "请输入程序名称",
 "XeIKK7": "通知中心",
 "XeiAal": "删除",
 "Xi/+KE": "新增时段",
 "XnimdQ": "Windows",
 "Xsx53E": "请问您确认要移除此文件吗？",
 "Y2Wh/g": "视频文件（*.mp4/*.mov）",
 "Y6Q+iJ": "请填写wifi配置",
 "YIgP+p": "设备排程列表",
 "YLvNj+": "待部署",
 "YeF1dY": "时区",
 "Yh8vRi": "开启后，若{ora}有新版本时将自动下载与更新。",
 "Ym4SPE": "选择发布时间（设备执行时间）",
 "Ymq1/H": "设备文件夹名称",
 "YpXN8m": "最后触发时间",
 "YuZxve": "选择内容",
 "YwEzx2": "勾选需要显示的栏位",
 "YzG9Iw": "黑名单",
 "Z2B362": "持续",
 "Z56D+X": "关闭排程任务",
 "ZBDct6": "失败：{num}",
 "ZC7J/S": "通知类型",
 "ZETl7o": "报警模板",
 "ZHAjhZ": "输入上限：30",
 "ZK1d6f": "SSID",
 "ZMUuo8": "确定要启用吗？",
 "ZPSpaL": "报警模块名称",
 "ZUPzqr": "开启",
 "ZWN1C0": "是否确认启用（{name}）该命名规则？",
 "ZdO12B": "套用门店",
 "ZqioaF": "通知标题",
 "Zr9Dss": "失败",
 "ZtZ7Yw": "程序名称",
 "Zvt+2g": "仓储",
 "a++4i0": "发布时间必须在24小时后",
 "aBleoN": "选择报警模板",
 "aGxRt2": "内容",
 "aHlr3k": "移除",
 "aKxrop": "删除排程模板的套用",
 "aN+DgN": "激活时间",
 "adMZWx": "添加周边设备",
 "aiBGBs": "删除成功",
 "ajVpLe": "是否确认删除该报警历史？",
 "aqQg0p": "区域",
 "arp+TQ": "50条/页",
 "azDNha": "发送成功",
 "b1xi4S": "预览模板",
 "b5l2vN": "保存",
 "b6y8Ai": "是否确认禁用（{name}）该排程？",
 "b95U3r": "配置文件列表",
 "bE+h3K": "设备状态",
 "bGGvOS": "选择图片",
 "bKLb1C": "播放",
 "bLP2/B": "查看设置套用状态",
 "bMdSkq": "网络测速记录",
 "bOKDVF": "切换单选",
 "bYIKFB": "进行中：{num}",
 "bYujGa": "创建模板",
 "baNBmh": "图片大小不能超过500KB",
 "batMBC": "是否确认删除（{name}）该模板？",
 "bbMhTk": "是否确认重启？",
 "bhv+8O": "下载中",
 "bneXBI": "变更提示",
 "bqbDVw": "查询",
 "bsjenW": "启用命名规则",
 "c5daOt": "门店数 ({num})",
 "c7ABGP": "功能部署正在等待 Ora 的响应",
 "c8uKl6": "Wi-Fi",
 "cDZ00w": "查看",
 "cX08hK": "未选择任何数据",
 "cawvIS": "最后更新时间",
 "cijnrq": "已安装设备",
 "czLSET": "手动新增应用程序",
 "d+otpZ": "发布版本",
 "d8xSfX": "版本代码",
 "dEXfrL": "设备健康状态区间",
 "dGBGbt": "全部",
 "dRYBRc": "版本号：{version}",
 "dY3og7": "上传App icon：",
 "dZlNkV": "添加配置",
 "devicesList@1": "选择全部设备",
 "devicesList@2": "选择全部设备",
 "dmEBpU": "文件同步配置",
 "drCsUI": "公司",
 "e/6XZC": "没有收到验证码？",
 "e2ys3T": "门店配置信息",
 "e8OyHO": "20条/页",
 "eAgY2G": "展开子公司",
 "eCCa0L": "任务类型",
 "eFDqHN": "上传Windows应用程序成功",
 "eSfTZf": "上传Windows应用程序",
 "eUNh5K": "待安装设备",
 "ecTX+c": "程序名称必填",
 "eeCxuz": "OS类型",
 "eg9Cwk": "从目前定位公司",
 "epaa3H": "添加命名规则",
 "evJP5c": "命名规则",
 "f7Dpbl": "下载范本，根据范本提示完善内容",
 "f8ijF3": "命令已下发",
 "f9tP6e": "请问您确认要移除此Windows应用程序吗？",
 "fFaC3Z": "播放时段",
 "fX0dsH": "版本：",
 "fje/m/": "模板名称：",
 "fl7J8Y": "讯息",
 "foT1aq": "当前上传进度：",
 "fq3WGG": "配置文件管理",
 "fr4nkj": "是否确认删除报警历史？",
 "ftJgyV": "必须勾选一个设备",
 "fz2pkM": "该节点已被删除",
 "g5Pknn": "文件大小超过限制",
 "g8yytK": "已读",
 "gH+Az7": "禁用排程",
 "gQ7kPU": "Android",
 "gU4eZD": "报警管理",
 "gVXoXc": "内容管理",
 "gY9Idz": "通知内容",
 "ggvI6Z": "全选",
 "ghKe/+": "进程名",
 "gi4oTZ": "排程模板列表",
 "gltp3e": "关闭Windows通知",
 "gnNjS5": "个人设备名称",
 "gomg5W": "禁用提醒",
 "gplM71": "每日",
 "gweUAO": "锁定USB接口",
 "gyHdsW": "配置模板",
 "gyh+d1": "有线网络",
 "gzHM5l": "报警发布日期",
 "h5yj+x": "请输入进程名称",
 "h7w4pz": "暂无数据",
 "hAd+eG": "设备排程日历",
 "hD/l+2": "操作类型",
 "hD7/Lu": "显示",
 "hDmGQl": "是否校验版本代码",
 "hDx3/S": "邮箱",
 "hMboy7": "命令状态详情",
 "hYN7oM": "隐藏",
 "hfn1Ux": "成功/总数",
 "hkJXyi": "配置排程任务",
 "hkR3E+": "查看模式",
 "hmCei2": "移除后卸载app",
 "hqGPDw": "启用24小时格式",
 "hwlmeB": "目标类型",
 "hxy4wV": "解析中",
 "i5JzAA": "状态：",
 "i5MLJc": "最后更新时间：{lastUpdate}",
 "i6kDf/": "选择设备中包含{num}台Nubis Free版本，将无法进行设备命令。",
 "i8wqAy": "上传本地应用",
 "i9lOCU": "您选择的开始日期早于今天",
 "iHQiQV": "批量播放",
 "iJIOBp": "解析失败",
 "iKomBu": "暂无分类",
 "iN7Lps": "循环模式",
 "iRR+fJ": "debugInfo",
 "ibYzs0": "程序名称：{name}",
 "ich0wH": "设备SN",
 "ie9Iom": "查看配置模板",
 "ieTzi7": "报警模板详情",
 "ifAmoA": "配置文件模板",
 "ifGp4v": "2FA",
 "ii1TCF": "(请把压缩包中的bat文件命名为install或者uninstall)",
 "imhWD8": "上传设置",
 "iroVTo": "公司设置",
 "iscUWH": "完成：{num}",
 "ivzCMK": "该应用程序无法解析。",
 "iyOrrD": "100条/页",
 "j/YGZ0": "地图",
 "j2kqd8": "删除命名规则",
 "j3QWSE": "自然数递增的起始号码只能为正整数",
 "j3iWkN": "打印机不能重复",
 "j6Hm96": "排程执行",
 "j6IHvr": "查看详情",
 "jAAXdQ": "设备门店",
 "jAJbuk": "通知公告",
 "jCAPQ2": "{nubis} Cast模式",
 "jG/AFY": "确认后设备将套用新的配置,且一天内无法再变更设定,确定要套用吗?",
 "jN5tO+": "版本代码：{versionCode}",
 "jNiwk6": "是否确认删除（{name}）该报警设备？",
 "jNxbTC": "验证码不能为空",
 "jT6zKT": "设备数",
 "jdbKm7": "报警通知对象",
 "jddlWH": "部署失败",
 "jhfb/7": "保存成功",
 "js3tZs": "排程模板名称",
 "k+a7BC": "执行静默更新时间",
 "k30s+D": "最后发布时间",
 "k7dy8j": "关联配置文件",
 "k9dozc": "执行时间",
 "kCh5Jz": "提示",
 "kG2Etz": "在线",
 "kH9MHe": "禁用命名规则",
 "kL3ndq": "是否移除该打印机?",
 "kNhfaL": "是否确认删除模板({name}）",
 "kUagYW": "排程执行历史记录",
 "kUbrNT": "请先上传文件至资源管理中心。模板只能使用审核通过的文件。",
 "khyRcw": "请选择Excel文件",
 "kkLQie": "关联门店",
 "kqgd4D": "至少添加一个执行时间",
 "kr+7Iy": "搜索门店",
 "ksb/lB": "是否删除原程序",
 "ktaxSw": "未读",
 "kwOS33": "启用提醒",
 "l0mW6t": "最新更新时间",
 "l1fZNE": "不可全部取消勾选",
 "l7IiCY": "排程状态",
 "l9XE8F": "通过",
 "lLa/D3": "套用类型",
 "lPA1qT": "此配置只针对特定设备",
 "lchpP8": "应用成功",
 "loTFGc": "未命名",
 "lqQKL4": "通过进程名添加",
 "lsLYU/": "通知上限次数不能超过10",
 "lzP/we": "ORA下载",
 "m0Qdyj": "验证失败",
 "m1h20o": "若后续排程模板的内容有更新，也会同步给套用的设备",
 "m8CFrl": "新建模板",
 "mC2//O": "查看排程日历",
 "mISQTh": "详细内容",
 "mRHwkp": "是否确认禁用（{name}）该模板？禁用后设备无法引用该模板",
 "mYa6W/": "自定义文字",
 "ma6S6y": "自定义显示",
 "miANEg": "是否确认关闭（{name}）该排程任务？关闭后设备将不执行该排程任务。",
 "mmGD7U": "功能部署正在进行中。",
 "mml+gT": "选择应用",
 "mn0ceu": "有重复的配置规则，请调整",
 "mpeFt+": "报警规则",
 "n1yIyi": "安装时间",
 "n997QX": "视频高度",
 "nDwIwd": "已发布",
 "nGubXb": "排程模板详情",
 "nH1F3p": "是否确认删除（{name}）当前报警规则？",
 "nJCPaY": "用户没有绑定邮箱，无法进行验证",
 "nJetAr": "不支持的格式。",
 "nLERtc": "更新Android应用程序",
 "nMMNa6": "我们会透过电子邮件、短信或系统通知您。",
 "nUSeQB": "未选择账号",
 "nbp4U6": "内容模板列表",
 "ngLF8L": "是否确认将（{name}）的排程执行记录删除？",
 "nqPJwo": "针对标签",
 "nqPOJc": "是否确认开启（{name}）该排程任务？开启后设备需执行该排程任务。",
 "nw8orn": "通知人数",
 "nxeBGd": "示例：",
 "nzsNwZ": "设备健康状态",
 "o8HwKf": "文件名",
 "o8tJYm": "设备命令",
 "o9bMHL": "大小",
 "oC6GBl": "Android应用程序",
 "oCogiy": "命令",
 "oFt+cN": "网络测速",
 "oUgWVb": "类型: {type}",
 "oV0gpL": "排程发布日期",
 "oXfYag": "版本代码已存在，请重新上传",
 "oY0m24": "使用者",
 "oirnwv": "启用排程模板",
 "ojz0Ke": "查看更多 >",
 "oru5FY": "编辑排程模板",
 "ovdKZi": "无法安装设备数",
 "p+zOzc": "结果",
 "p/3Nn5": "移动网络",
 "p/EHrl": "视频最大不能超过10GB",
 "pBPyFt": "Nubis版本",
 "pGioLb": "设备序SN",
 "pV2t/S": "基本信息",
 "pcU9bM": "添加成员",
 "peNVzr": "每{num}周",
 "pfGGi0": "移除设备目前所套用的排程模板，不再执行",
 "pielKO": "开机设备",
 "pkYJKs": "执行状态",
 "pm5kAg": "内容请在详情查看",
 "q6qKtH": "查询条件：",
 "q9PHLT": "暂无公告",
 "qDHqff": "自动重启",
 "qDba8m": "离线设备状态",
 "qG2/EZ": "本地档案上传",
 "qH+vs7": "白名单",
 "qS0aFJ": "应用管理",
 "qTgFpp": "从账号所属公司",
 "qUKj7E": "复制",
 "qUiH5y": "配置规则不能为空",
 "qhku2P": "(暂不支持windows7)",
 "qjtl3b": "启用系统更新",
 "qqwM/t": "配置文件",
 "qwHBkg": "没有设置变更的记录，设备皆采用预设设置",
 "qx5UwR": "请选择一个设备",
 "r+yR7v": "{nubis} Cast",
 "r0/TUu": "确定",
 "r2dEd/": "重置",
 "r8lAlx": "周边管理",
 "rBD8kj": "图片横坐标",
 "rDRAr0": "作业系统版本",
 "rUHCoM": "设备排程",
 "rULuF3": "是否仅允许以下网络连接",
 "rdEPl7": "无法安装设备",
 "rnpMD3": "关",
 "rsAvN6": "程序名称：",
 "rw3uGa": "新建配置模板",
 "s+OQvW": "操作者",
 "s+aIlP": "搜索门店名称",
 "s7NSze": "确认操作前请先请输入您的账户密码",
 "s9U9qn": "设置报警",
 "sB85Wu": "本地上传",
 "sOIerB": "未激活",
 "sWmzFs": "{ora}最后更新时间",
 "sZSyGZ": "启用",
 "sb1vdX": "进行中",
 "sctjLN": "{ora}最后上线时间",
 "srEpKw": "正在上传",
 "srpWCM": "勾选需要显示的栏位，可拖动进行排序",
 "sux9FA": "输入下限：1",
 "t2iHNJ": "更新",
 "t8R6VW": "程序包ID：{package}",
 "tAjFr2": "图片格式：PNG、JPG、JPEG、BMP、GIF、SVG、WEBP",
 "tCh+iz": "报警发布时间",
 "tFr3tb": "是否确认删除（{name}）该报警模板？删除后将同步取消设备，门店及标签对本模板的套用。",
 "tIm58E": "停止",
 "tLW3W3": "手机号",
 "tR69qg": "Windows显示语言",
 "tRm3bw": "暂停成功",
 "tWcCoB": "测速日期",
 "tnYpSo": "侦测请求发送成功",
 "tokMPz": "例外对象",
 "tp71Dv": "必须设置Windows设备路径",
 "tugHWJ": "返回公告列表",
 "twpxdo": "上传Android应用程序",
 "u/NB+Y": "程序包ID",
 "u3dVQz": "每周",
 "uCmncQ": "视频宽度",
 "uL4MGN": "请问您确认要移除此Android应用程序吗？",
 "uf58G7": "关闭自动更新后，设备上{ora}版本差异可能会导致部分功能无法使用",
 "uhTa0i": "预览",
 "uoBkfP": "{ora}最后更新状态",
 "uoZwj+": "创建人",
 "uqEE8V": "此配置仅适用于Android Ora 2.14.25",
 "urr92/": "选择部署人",
 "uuRzdk": "归属门店",
 "v04auv": "结束时间",
 "vD5wnY": "勾选要归属的门店，代表拥有该门店的权限",
 "vDCwZ9": "上传文件",
 "vLW90z": "是否确认删除（{name}）该命名规则？",
 "vovKL8": "应用路径不能为空",
 "vr5TVT": "请输入",
 "vtUGfp": "公司默认命名规则",
 "w1cMGO": "结束日期",
 "w8L9Kj": "配置报警规则",
 "wDqNy1": "示例",
 "wIFJtf": "未连接",
 "wOHHSJ": "上移",
 "wQAiLI": "重置提醒",
 "wYygRu": "发送人",
 "wboZY3": "回报时间",
 "wiSRo9": "安装设备数",
 "wnPTP+": "输入设备SN",
 "wrU/Kc": "每{num}天",
 "wyHcKZ": "批准提醒",
 "x/FhNQ": "查看通知",
 "xAk1ic": "该功能已成功部署",
 "xE1H+X": "设置",
 "xISm1t": "激活",
 "xNeD5U": "已取消",
 "xUjLTE": "搜索",
 "xdjVt1": "未填写模板名称",
 "xiwfUp": "音量",
 "xlNcvg": "最近更新时间：",
 "xrQzKh": "请填写应用名称，例如 chrome",
 "xtHJEE": "未选择任何记录",
 "xwYDb8": "版本代码：",
 "xzmRTb": "仅显示近7天的历史纪录",
 "y8e4w8": "仅在设备重启后生效",
 "y98D3X": "视频纵坐标",
 "y9NWzQ": "报警设备列表",
 "yGWx2z": "参数错误",
 "yOMNOj": "是",
 "yReEcE": "选择标签",
 "yWzW01": "(exe安装程序、msi文件、zip压缩包)",
 "yXsHgv": "10条/页",
 "yb3AuG": "离线",
 "ybGQQ3": "无相关结果",
 "yc8eep": "选择结果",
 "ydktLD": "分隔符",
 "yfhtRM": "附件",
 "ygAHaf": "发送时间",
 "yiO/gL": "模板列表",
 "yifWnc": "是否确认将排程执行记录删除？",
 "yrR/HC": "安装中",
 "yvnu2T": "配置模板名称",
 "yxPDHk": "发布状态",
 "z5L9EV": "更新Windows应用程序",
 "zH7h1q": "历史记录",
 "zKsJJS": "是否确认启用该USB端口?",
 "zY36V+": "已连接",
 "zbqD5q": "值",
 "zeMk2K": "草稿",
 "znna6r": "门店信息",
 "zok1hp": "C槽",
 "ztKQno": "时长",
 "zvaxmN": "排程管理",
 "zyMKgy": "选择门店"
}